import React, { useRef, useEffect } from 'react';
import { Button, Icon, Empty } from 'antd';
import DispexButton from '../DispexButton/DispexButton';
import { getValueByPath } from '../../helpers/getValueByPath';
import cn from 'classnames';
import styles from './CheckMarkMenu.module.scss';
import { FilterItemParentContent } from '../../containers/Statistics/components/FilterItemParentContent/FilterItemParentContent';

const CheckMarkMenu = ({
  rootClassName,
  renderSearchInput,
  handlers = {
    onDeselectAll: undefined,
    onSelectAll: undefined,
    onMenuClick: undefined,
    onConfirm: undefined,
  },
  parentItemHandlers = {
    onMultySelect: undefined,
    onMultyDeselect: undefined,
    checked: false,
  },
  showCheckbox,
  items = [],
  emptyText = 'Нет данных',
  valueKey = 'id',
  selectedItems = [],
  renderContent,
  visible,
}) => {
  const inputRef = useRef();

  useEffect(() => {
    if (inputRef.current && visible) {
      inputRef.current.focus();
    }
  }, [inputRef, visible]);

  return (
    <div className={cn(styles.root, rootClassName)}>
      {typeof renderSearchInput === 'function' && (
        <div className={styles.container}>
          {renderSearchInput({ inputRef })}
        </div>
      )}

      {items.length === 0 && (
        <Empty
          description={emptyText}
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      )}

      {items.length > 0 && (
        <>
          {(typeof handlers.onSelectAll === 'function' ||
            typeof handlers.onDeselectAll === 'function') && (
            <div className={cn(styles.selectionBlock, styles.container)}>
              {typeof handlers.onSelectAll === 'function' && (
                <Button
                  className={styles.selectionButton}
                  type="link"
                  onClick={handlers.onSelectAll}
                >
                  Выделить все
                </Button>
              )}
              {typeof handlers.onDeselectAll === 'function' && (
                <Button
                  className={styles.selectionButton}
                  type="link"
                  onClick={handlers.onDeselectAll}
                >
                  Снять все
                </Button>
              )}
            </div>
          )}
          <ul className={styles.list}>
            {items.map((item) => (
              <React.Fragment key={item[valueKey]}>
                {!item?.childrens && !item?.childrens?.length ? (
                  <li
                    className={styles.listItem}
                    onClick={() => handlers.onMenuClick(item)}
                  >
                    {renderContent(item)}
                    <div className={styles.iconWrap}>
                      {selectedItems.includes(
                        getValueByPath(item, valueKey)
                      ) && (
                        <Icon
                          type="check"
                          className={styles.selectedIcon}
                        />
                      )}
                    </div>
                  </li>
                ) : (
                  <li className={styles.listItem_parent}>
                    <FilterItemParentContent
                      item={item}
                      handleMultySelect={parentItemHandlers.onMultySelect}
                      handleMultyDeselect={parentItemHandlers.onMultyDeselect}
                      showCheckbox={showCheckbox}
                      checked={
                        typeof parentItemHandlers.checked === 'function'
                          ? parentItemHandlers.checked(item)
                          : parentItemHandlers.checked
                      }
                    />
                    <ul>
                      {item.childrens.map((item) => (
                        <li
                          className={styles.listItem}
                          key={`${item[valueKey]}_${item.id}`}
                          onClick={() => handlers.onMenuClick(item)}
                        >
                          {renderContent(item)}
                          <div className={styles.iconWrap}>
                            {selectedItems.includes(
                              getValueByPath(item, valueKey)
                            ) && (
                              <Icon
                                type="check"
                                className={styles.selectedIcon}
                              />
                            )}
                          </div>
                        </li>
                      ))}
                    </ul>
                  </li>
                )}
              </React.Fragment>
            ))}
          </ul>
          {typeof handlers.onConfirm === 'function' && (
            <div className={styles.container}>
              <DispexButton
                type="secondary"
                onClick={handlers.onConfirm}
                className={styles.confirmButton}
              >
                Применить
              </DispexButton>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default CheckMarkMenu;
